import { atom, createStore } from 'jotai';
import getGranularity from '@utils/granularity';
import { utcMoment } from '../utils';

// product key is being used to identify the dataset. which is used to query metric gateway
export const usageMetricList: any = {
  IntervalMinutesPlayedWithAds: {
    product: 'EI',
    metricName: 'IntervalMinutesPlayedWithAds',
    displayName: 'Total Viewer Hrs',
    tooltipText:
      'Viewers Hours (Playing Time Interval): Content + Server Side Ads Hrs + Client Side Ads Hrs',
    localUnit: '',
  },
  ConcurrentPlays: {
    product: 'EI',
    metricName: 'ConcurrentPlays',
    displayName: 'Video Concurrent Plays',
    localUnit: '',
  },
  UserActiveTime: {
    product: 'APP',
    metricName: 'UserActiveTime',
    displayName: 'User Active Hrs',
    localUnit: '',
  },
  AppTotalUserEvents: {
    product: 'APP',
    metricName: 'AppTotalUserEvents',
    displayName: 'Event / Hr',
    localUnit: '',
  },
  AppTotalEvents: {
    product: 'APP',
    metricName: 'AppTotalEvents',
    displayName: 'Total Events',
    localUnit: '',
  },
  RealtimeAPICalls: {
    product: 'API',
    metricName: 'RealtimeAPICalls',
    displayName: 'Realtime API calls',
    localUnit: '',
  },
  HistoricalAPICalls: {
    product: 'API',
    metricName: 'HistoricalAPICalls',
    displayName: 'Historical API calls',
    localUnit: '',
  },
};

const intervalAtom: any = atom(null);
const granularityAtom = atom('PT1H');
const videoAccountsDetailsAtom: any = atom([]);
const appAccountsDetailsAtom: any = atom([]);
const apiAccountsDetailsAtom: any = atom([]);

function initStore() {
  const store = createStore();
  const lastMonthInterval: any = [
    utcMoment().subtract(1, 'month').startOf('month'),
    utcMoment().subtract(1, 'month').endOf('month'),
  ];

  store.set(intervalAtom, lastMonthInterval);
  store.set(granularityAtom, getGranularity(lastMonthInterval[0], lastMonthInterval[1]));

  return store;
}

export {
  intervalAtom,
  granularityAtom,
  videoAccountsDetailsAtom,
  appAccountsDetailsAtom,
  apiAccountsDetailsAtom,
  initStore,
};
